__turbopack_context__.v({
  "carouselContainer": "nLVzwa_carouselContainer",
  "carouselSlide": "nLVzwa_carouselSlide",
  "carouselTrack": "nLVzwa_carouselTrack",
  "floaterSpan": "nLVzwa_floaterSpan",
  "iconContainer": "nLVzwa_iconContainer",
  "navButton": "nLVzwa_navButton",
  "nextButton": "nLVzwa_nextButton" + " " + "nLVzwa_navButton",
  "prevButton": "nLVzwa_prevButton" + " " + "nLVzwa_navButton",
  "tab": "nLVzwa_tab",
  "tabsBar": "nLVzwa_tabsBar",
  "tabsContainer": "nLVzwa_tabsContainer",
});
